<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button (click)="cancelModal()">
                <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-buttons slot="end">
        </ion-buttons>
        <ion-searchbar placeholder="Search Product" debounce="300" [(ngModel)]="queryText"></ion-searchbar>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-refresher slot="fixed" (ionRefresh)="fetchEquipment($event)">
        <ion-refresher-content
                pullingIcon="arrow-dropdown"
                pullingText="Pull to refresh"
                refreshingSpinner="circles"
                refreshingText="Updating Equipment...">
        </ion-refresher-content>
    </ion-refresher>
    <ion-content>
        <ion-virtual-scroll [items]="equipmentList | filterDetailLine: queryText">
            <ion-item *virtualItem="let equip">
                <ion-checkbox [(ngModel)]="equip.isChecked" color="success"></ion-checkbox>
                <ion-label class="ion-text-wrap ion-padding-start">
                    <h4>{{equip.pdesc}} {{equip.reg ? equip.reg : ''}}</h4>
                    <p>{{equip.description}}</p>
                </ion-label>
                <ion-input *ngIf="equip.typ !== 'S'" type="number" [(ngModel)]="equip.qty"
                           (ionChange)="equip.isChecked = true" class="ion-text-end ion-padding-end" placeholder="0">
                </ion-input>
                <ion-icon *ngIf="equip.stat !== 1 && (document.documentType === 1 || document.documentType === 102 || document.documentType === 19 ) && equip.typ === 'S'"
                    name="man" slot="end"></ion-icon>
            </ion-item>
        </ion-virtual-scroll>
    </ion-content>

    <ion-fab vertical="bottom" horizontal="end" slot="fixed">
        <ion-fab-button (click)="addProducts()" color="success">
            <ion-icon name="checkmark"></ion-icon>
        </ion-fab-button>
    </ion-fab>
</ion-content>

<ion-footer>
    <p class="ion-text-center" style="color: darkgrey">Last Update: {{lastUpdate | date: "dd/MM/yyyy HH:mm:ss"}}</p>
</ion-footer>
